import api from '@/api/axiosApi'

export async function fetchColumnWidths(
  planId: string
): Promise<Record<string, number>> {
  const { data } = await api.get<{ widths: Record<string, number> }>(
    `/plans/${planId}/column-widths`
  )
  return data.widths
}

export async function upsertColumnWidth(
  planId: string,
  columnKey: string,
  width: number
): Promise<void> {
  await api.put(
    `/plans/${planId}/column-widths/${encodeURIComponent(columnKey)}`,
    { width }
  )
}
